import React, { useState } from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import Logo from "../../assets/SalonTym_Logo.png";
import {
  Box,
  InputAdornment,
  MenuItem,
  Select,
  Typography,
  styled,
} from "@mui/material";
import Image from "next/image";
import { ApiService } from "../../services/AppService";
import {
  ResponseObject,
  CustomerOtpVerificationRequest,
} from "../../classes/main";
import { saveToken } from "../../services/HolderService";
import SignUpProfile from "../profile/SignUpProfile";
import { trackEvent } from "@/app/utils/branch";
import Link from "next/link";
import { Loader } from "../genericComponents/MainLoader/Loader";

const Input = styled(TextField)(({ theme }) => ({
  "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
    display: "none",
  },
  "& input[type=number]": {
    MozAppearance: "textfield",
  },
}));

interface LoginProps {
  showLoginBox: any;
  handleLoginClose: any;
  handleUserLoggedIn: any;
}

const Login: React.FC<LoginProps> = ({
  showLoginBox,
  handleLoginClose,
  handleUserLoggedIn,
}) => {
  const apiService = new ApiService();
  const [mobileNumber, SetMobileNumber] = useState("");
  const [otp, setOtp] = useState("");
  const [showOtpInput, setShowOtpInput] = useState(false);
  const [validNumber, setValidNumber] = useState(false);
  const [validOtp, setValidOtp] = useState(false);
  const [signUpForm, setSignUpForm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [countryCode, setCountryCode] = useState("91");

  const handleCodeChange = (event: any) => {
    setCountryCode(event.target.value);
  };

  const handleMobileNumber = (e: any) => {
    SetMobileNumber(e.target.value);
  };

  const handleOtp = (e: any) => {
    setOtp(e.target.value);
  };

  const handleClose = () => {
    handleLoginClose();
  };

  const handleLoginCloseAfterSignUp = () => {
    handleLoginClose();
    setSignUpForm(false);
  };

  async function sendOtpToCustomer() {
    const responseObject: ResponseObject | undefined =
      await apiService.get<ResponseObject>(
        apiService.sendOtp +
          "?username=" +
          mobileNumber +
          "&prefix=" +
          countryCode
      );

    if (responseObject?.status == "success") {
      setShowOtpInput(true);
      setValidNumber(false);
    } else {
    }
    // console.log("Error : " + responseObject);
  }
  async function verifyOtp() {
    // console.log("submitted");
    const customerVerification: CustomerOtpVerificationRequest =
      new CustomerOtpVerificationRequest();
    customerVerification.username = mobileNumber;
    customerVerification.otp = otp;
    customerVerification.prefix = countryCode;
    const responseObject: ResponseObject | undefined = await apiService.post(
      apiService.verifyOtp,
      customerVerification
    );
    // console.log(responseObject);
    if (responseObject?.status == "success") {
      if (responseObject?.object?.statusCode == 1) {
        setValidNumber(false);
        setShowOtpInput(false);
        handleUserLoggedIn();
        SetMobileNumber("");
        setOtp("");
        saveToken(responseObject.message);
        setSignUpForm(true);
        trackEvent("LOGIN", null);
        // window.location.reload();
      } else {
        setValidNumber(false);
        setShowOtpInput(false);
        handleUserLoggedIn();
        SetMobileNumber("");
        setOtp("");
        saveToken(responseObject.message);
        setSignUpForm(false);
        handleLoginClose();
        trackEvent("LOGIN", null);
        window.location.reload();
      }
    } else {
      alert(responseObject?.message);
    }
  }

  const handleSubmit = (e: any) => {
    e.preventDefault();
    const mobileNumberVaidation =
      mobileNumber && mobileNumber.toString().length === 10;
    if (mobileNumberVaidation) {
      if (mobileNumberVaidation && showOtpInput === true) {
        if (otp) {
          verifyOtp();
        } else {
          setValidOtp(true);
        }
      } else {
        sendOtpToCustomer();
      }
    } else {
      setValidNumber(true);
    }
  };

  return (
    <React.Fragment>
      {loading && <Loader />}
      <Dialog
        open={showLoginBox}
        onClose={handleClose}
        closeAfterTransition={false}
        // aria-hidden={true}
        sx={{
          "@media (max-width: 600px)": {
            "& .MuiDialog-paper": {
              width: "100%",
              height: "100%",
              maxHeight: "100%",
              margin: 0,
            },
          },
        }}
      >
        {!signUpForm ? (
          <Box>
            <DialogTitle style={{ textAlign: "right", paddingBottom: "0px" }}>
              <CloseIcon style={{ cursor: "pointer" }} onClick={handleClose} />
            </DialogTitle>
            <DialogContent
              style={{ textAlign: "center", paddingBottom: "10px" }}
            >
              <Image
                src={Logo}
                alt="Logo"
                style={{
                  width: "150px",
                  paddingBottom: "20px",
                  margin: "auto",
                  height: "auto",
                }}
                height={500}
                width={500}
              />
              <Input
                autoFocus
                required
                margin="dense"
                type="number"
                label="Mobile Number"
                value={mobileNumber}
                onChange={handleMobileNumber}
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Select
                        value={countryCode}
                        onChange={handleCodeChange}
                        variant="standard"
                        disableUnderline
                        sx={{
                          fontSize: "0.9rem",
                          minWidth: "60px",
                          background: "#fff",
                        }}
                      >
                        <MenuItem value="91">🇮🇳 +91</MenuItem>
                        <MenuItem value="977">🇳🇵 +977</MenuItem>
                      </Select>
                    </InputAdornment>
                  ),
                }}
                sx={{
                  "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                    {
                      borderColor: "#005200",
                    },
                }}
              />
              {showOtpInput && (
                <Box sx={{ textAlign: "end" }}>
                  <Button
                    style={{ textTransform: "capitalize", padding: "4px" }}
                    variant="text"
                    disableElevation
                    onClick={sendOtpToCustomer}
                  >
                    Resend OTP
                  </Button>
                </Box>
              )}
              <Typography
                style={{
                  color: "red",
                  margin: "auto",
                }}
              >
                {validNumber
                  ? "Please enter a valid 10-digit mobile number"
                  : ""}
              </Typography>
              {showOtpInput ? (
                <Box>
                  <Input
                    autoFocus
                    required
                    label="OTP"
                    type="number"
                    margin="dense"
                    fullWidth
                    onChange={handleOtp}
                    value={otp}
                    sx={{
                      "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                        {
                          borderColor: "#005200",
                        },
                    }}
                  />
                </Box>
              ) : (
                ""
              )}
              <Typography style={{ color: "red", margin: "auto" }}>
                {validOtp ? "Please enter OTP" : ""}
              </Typography>
            </DialogContent>
            <DialogActions>
              <Button
                variant="contained"
                color="success"
                fullWidth
                sx={{
                  padding: "8px 10px",
                  borderRadius: "20px",
                  margin: "0px 10px",
                  background: "#005200",
                }}
                onClick={handleSubmit}
              >
                Continue
              </Button>
            </DialogActions>
            <DialogContent
              style={{
                color: "gray",
                fontSize: "15px",
                paddingTop: "0px",
                paddingBottom: "0px",
                margin: "auto",
                textAlign: "center",
              }}
            >
              By Continuing, you agree to our{" "}
              <Link
                href="/privacy-policy"
                style={{ color: "#000", textDecoration: "underline" }}
                onClick={() => setLoading(true)}
              >
                terms & conditions
              </Link>{" "}
              &{" "}
              <Link
                href="/privacy-policy"
                style={{ color: "#000", textDecoration: "underline" }}
                onClick={() => setLoading(true)}
              >
                Privacy policy
              </Link>
            </DialogContent>
            <DialogContent>
              <Typography
                variant="body1"
                sx={{
                  fontSize: "62px",
                  color: "#000",
                  opacity: 0.2,
                  fontWeight: "bold",
                }}
              >
                Seize <br /> the day!
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: "20px",
                  color: "#000",
                  opacity: 0.2,
                  fontWeight: "bold",
                }}
              >
                Made with ❤️ in Noida, Inida
              </Typography>
            </DialogContent>
          </Box>
        ) : (
          <Box sx={{ minWidth: { xs: "auto", sm: "500px" } }}>
            <DialogTitle style={{ textAlign: "right", paddingBottom: "0px" }}>
              <CloseIcon style={{ cursor: "pointer" }} onClick={handleClose} />
            </DialogTitle>
            <SignUpProfile
              handleLoginCloseAfterSignUp={handleLoginCloseAfterSignUp}
            />
          </Box>
        )}
      </Dialog>
    </React.Fragment>
  );
};

export default Login;
